
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import CalendarPage from '../pages/calendar/page';
import ListsPage from '../pages/lists/page';
import ProfilePage from '../pages/profile/page';
import MessagesPage from '../pages/messages/page';
import GalleryPage from '../pages/gallery/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/calendar',
    element: <CalendarPage />
  },
  {
    path: '/lists',
    element: <ListsPage />
  },
  {
    path: '/messages',
    element: <MessagesPage />
  },
  {
    path: '/gallery',
    element: <GalleryPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
